import { Breakpoints, TokenTextAppearance, styled } from '@volkswagen-onehub/components-core';
import React from 'react';
import { getTranslations } from "../translations";
import { HomeHeader } from '../Filtering/modal/HomeHeader';
import { VolksKlickLogotype } from '../svg/VolksKlick/Brand/Logotype';

const StepsContainer = styled.div`
    width: 100%;
    margin: 0 auto;
    border: 1px solid #000;
    padding: 1rem;
    max-width: 90%;

    @media screen and (min-width: ${Breakpoints.b960}px) {
      max-width: 60%;
    }
`;

const StepWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 1rem;
  align-items: center;

  @media (min-width: 780px) {
    grid-template-columns: 1fr 2fr;
  }
  `;

const StepDescription = styled.div`
  width: 100%;
  font-size: ${props => props.theme.size.static250};
  text-align: center;

  @media (min-width: 780px) {
    text-align: unset;
  }
`;

const StepLogo = styled.div``;

export const VolksKlick = () => {
  const { volksklick } = getTranslations();

  return (
    <>
      <HomeHeader />
      <StepsContainer>
        <StepWrapper>
          <StepLogo>
            <VolksKlickLogotype appearance={TokenTextAppearance.headline300} iconSize={{default: '3.5rem', b560: '3.5rem', b1600: '3.5rem'}} />
          </StepLogo>
          <StepDescription>{volksklick.copy}</StepDescription>
        </StepWrapper>
      </StepsContainer>
    </>
  );
};
